"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorSchema = exports.MembershipSchema = exports.GroupTypeSchema = exports.GroupType = exports.ActorTypeSchema = exports.ActorType = exports.MembershipRoleSchema = exports.MembershipRole = exports.UserRecordTypeSchema = exports.UserRecordType = void 0;
const zod_1 = require("zod");
var UserRecordType;
(function (UserRecordType) {
    UserRecordType["User"] = "user";
    UserRecordType["Organization"] = "organization";
})(UserRecordType || (exports.UserRecordType = UserRecordType = {}));
exports.UserRecordTypeSchema = zod_1.z.nativeEnum(UserRecordType);
var MembershipRole;
(function (MembershipRole) {
    MembershipRole["Admin"] = "admin";
    MembershipRole["Member"] = "member";
    MembershipRole["Trainee"] = "trainee";
})(MembershipRole || (exports.MembershipRole = MembershipRole = {}));
exports.MembershipRoleSchema = zod_1.z.nativeEnum(MembershipRole);
var ActorType;
(function (ActorType) {
    ActorType["User"] = "user";
    ActorType["Organization"] = "organization";
})(ActorType || (exports.ActorType = ActorType = {}));
exports.ActorTypeSchema = zod_1.z.nativeEnum(ActorType);
var GroupType;
(function (GroupType) {
    GroupType["Organization"] = "organization";
})(GroupType || (exports.GroupType = GroupType = {}));
exports.GroupTypeSchema = zod_1.z.nativeEnum(GroupType);
exports.MembershipSchema = zod_1.z.object({
    groupId: zod_1.z.string(),
    groupName: zod_1.z.string(),
    groupUsername: zod_1.z.string(),
    groupType: exports.GroupTypeSchema,
    role: exports.MembershipRoleSchema,
});
exports.ActorSchema = zod_1.z.object({
    type: exports.ActorTypeSchema,
    userId: zod_1.z.string(),
    email: zod_1.z.string(),
});
//# sourceMappingURL=authentication.types.js.map